// extracted by mini-css-extract-plugin
module.exports = {"box":"Blog_box__1yXE5","boxContent":"Blog_boxContent__1OBr9","title":"Blog_title__3Qd6P","post":"Blog_post__3I6Yb","icon":"Blog_icon__1Rcik"};